// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.de3e_Gvgn30I5Zx2QRr8{color:var(--content-primary-primary)}.G90ApFq4OEQW8XrQOXbq{flex-direction:column;align-items:center;gap:16px;margin-bottom:24px;display:flex}.GKS1Qo2BaLgqdCAdroyY{color:var(--content-primary-primary);font-size:40px;line-height:120%}.j3HTwYWGjYFj2uiuq83s{text-align:center;color:var(--content-primary-primary);letter-spacing:-.24px;margin-bottom:40px;font-size:40px;font-style:normal;font-weight:500;line-height:133.3%}.GTpXyul07VErYGuD40hL>div{padding:11px 12px}.kyRt2rUf5sIwvcslzZFP{width:100%;display:flex}._KouN0ZeTYoy9EkRyuFs{padding:2px 0;font-size:13px;font-style:normal;font-weight:500;line-height:normal}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `de3e_Gvgn30I5Zx2QRr8`,
	"content": `G90ApFq4OEQW8XrQOXbq`,
	"icon": `GKS1Qo2BaLgqdCAdroyY`,
	"phone": `j3HTwYWGjYFj2uiuq83s`,
	"alert": `GTpXyul07VErYGuD40hL`,
	"actionsWrap": `kyRt2rUf5sIwvcslzZFP`,
	"button": `_KouN0ZeTYoy9EkRyuFs`
};
export default ___CSS_LOADER_EXPORT___;
